import { apiGet, apiPatch } from './client';
import type {
  BenchmarkRatePeriod,
  BenchmarkRatePeriodBatchRequest,
} from '../types/BenchmarkRatePeriod';

export function getBenchmarkRatePeriods(): Promise<BenchmarkRatePeriod[]> {
  return apiGet<BenchmarkRatePeriod[]>('/api/benchmark-rate-periods');
}

export function saveBenchmarkRatePeriodsBatch(
  added: BenchmarkRatePeriod[],
  modified: BenchmarkRatePeriod[],
  deletedIds: number[],
): Promise<BenchmarkRatePeriod[]> {
  return apiPatch<BenchmarkRatePeriodBatchRequest, BenchmarkRatePeriod[]>(
    '/api/benchmark-rate-periods/batch',
    {
      added,
      modified,
      deleted: deletedIds,
    },
  );
}
